import { getListTransform, getDetailTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: true,
  buttonLoading: false,
  usage: null,
  usageLoading: false,
  deleteLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LIST_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.ITEM_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload.data) || INITIAL_STATE.detail,
        loading: false,
      };
    case types.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case types.USAGE_LOAD:
      return {
        ...state,
        usageLoading: action.payload,
      };
    case types.USAGE_FETCHED:
      return {
        ...state,
        usage: action.payload,
        usageLoading: false,
      };
    case types.USAGE_RESET:
      return {
        ...state,
        usage: INITIAL_STATE.usage,
        usageLoading: INITIAL_STATE.usageLoading,
        deleteLoading: INITIAL_STATE.deleteLoading,
      };
    case types.DELETE_LOAD:
      return {
        ...state,
        deleteLoading: action.payload,
      };
    default:
      return state;
  }
};
